import { baseAPI } from 'services/baseApi';

export const customDayApis = baseAPI.injectEndpoints({
  endpoints: (builder) => ({
    getCustomDaysListing: builder.query({
      query: ({ user = '', programId = '', weekId = '', from, limit }) => ({
        url: `custom-days/get-all?user=${user}&program=${programId}&week=${weekId}&from=${from}&limit=${limit}`,
        method: 'GET'
      }),
      providesTags: ['CUSTOM_DAYS']
    }),
    getCustomDayById: builder.query({
      query: ({ id }) => ({
        url: `custom-days/${id}`,
        method: 'GET'
      })
    }),
    // Anchor a day to a date; every later day of the program rolls forward from it.
    setCustomDayDateCascade: builder.mutation({
      query: ({ id, date }) => ({
        url: `custom-days/set-date-cascade/${id}`,
        method: 'PUT',
        body: { date }
      }),
      invalidatesTags: ['CUSTOM_DAYS']
    }),
    sortCustomDayList: builder.mutation({
      query: (payload) => ({
        url: 'custom-days/update/sortNo',
        method: 'PUT',
        body: payload
      }),
      invalidatesTags: ['CUSTOM_DAYS']
    }),
    addCustomDay: builder.mutation({
      query: (payload) => ({
        url: 'custom-days',
        method: 'POST',
        body: payload
      }),
      invalidatesTags: ['CUSTOM_DAYS']
    }),
    updateCustomDay: builder.mutation({
      query: ({ id, payload }) => ({
        url: 'custom-days/' + id,
        method: 'PUT',
        body: payload
      }),
      invalidatesTags: ['CUSTOM_DAYS']
    }),
    deleteCustomDayPermanently: builder.mutation({
      query: ({ id }) => ({
        url: 'custom-days/permanent/' + id,
        method: 'DELETE'
      }),
      invalidatesTags: ['CUSTOM_DAYS']
    }),
    deleteCustomDay: builder.mutation({
      query: ({ id }) => ({
        url: 'custom-days/' + id,
        method: 'DELETE'
      }),
      invalidatesTags: ['CUSTOM_DAYS']
    }),
    // Copy one day's blocks INTO another existing day (append).
    cloneCustomDayInto: builder.mutation({
      query: ({ id, target }) => ({
        url: 'clone/custom-day-into/' + id + '?target=' + target,
        method: 'GET'
      }),
      invalidatesTags: ['CUSTOM_DAYS', 'CUSTOM_BLOCKS']
    }),
    cloneCustomDay: builder.mutation({
      // week: optional destination — copy the day INTO another week.
      query: ({ id, week }) => ({
        url: 'clone/custom-day/' + id + (week ? '?week=' + week : ''),
        method: 'GET'
      }),
      invalidatesTags: ['CUSTOM_DAYS', 'CUSTOM_WEEKS']
    }),
    restoreCustomDay: builder.mutation({
      query: ({ id }) => ({
        url: 'custom-days/restore/' + id,
        method: 'PUT'
      }),
      invalidatesTags: ['CUSTOM_DAYS']
    })
  })
});

export const {
  useGetCustomDaysListingQuery,
  useSortCustomDayListMutation,
  useSetCustomDayDateCascadeMutation,
  useAddCustomDayMutation,
  useUpdateCustomDayMutation,
  useDeleteCustomDayPermanentlyMutation,
  useDeleteCustomDayMutation,
  useCloneCustomDayMutation,
  useCloneCustomDayIntoMutation,
  useRestoreCustomDayMutation,
  useLazyGetCustomDayByIdQuery
} = customDayApis;
